// extracted by mini-css-extract-plugin
var _1 = "CrossIcon-R9oQ5";
var _2 = "CrossIconContainer-bTqmY";
var _3 = "Pill-iRHxJ";
export { _1 as "CrossIcon", _2 as "CrossIconContainer", _3 as "Pill" }
